import { isEpgv2Enabled } from 'helpers/ConfigHelper';
import FoxLiveWrapper from './FoxLiveWrapper';
import Live from './Live';

export default isEpgv2Enabled() ? FoxLiveWrapper : Live;
